import {getCurrencySymbol} from '@functions/helpers/getCurrencySymbol';
import {useCallback, useEffect, useState} from 'react';
import {DEFAULT_MESSAGE_TYPE} from '@assets/helpers/campaign/defaultCampaignSetting';
import formatCurrencyValue from '@functions/helpers/currency/formatCurrencyValue';
import getUrlSearch from '@functions/helpers/getUrlSearch';

const useProductRecommendation = ({campaign, getData, isPreview = false}) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [fetchedRecommendedProduct, setFetchedRecommendedProduct] = useState(false);

  const {shop: shopDomain, country} = window.Shopify || {};
  const {type: messageType, productType} = campaign?.message || {};

  const createProductObject = (productData) => {
    if (!productData) return null;

    const firstVariant = productData.variants?.[0];
    const currency = window?.Shopify?.currency?.active;

    return {
      firstVariantId: firstVariant?.id?.split('/').pop(),
      name: productData.title || productData.name,
      price:
        getCurrencySymbol(currency) +
        ' ' +
        formatCurrencyValue(productData.priceRange.amount || firstVariant.price),
      img: productData.images?.[0]?.url || productData.img,
      onlineStoreUrl:
        productData.onlineStoreUrl ||
        `https://${window.Shopify?.shop}/products/${productData.handle}`
    };
  };

  const fetchRecommendedProduct = useCallback(async () => {
    try {
      if (!shopDomain || !country) return;

      const res = await getData(
        `/products/recommended?${getUrlSearch({
          shop: shopDomain,
          limit: 10,
          type: productType,
          country
        })}`
      );

      if (res.data) {
        const recommendedProduct = res.data[productType];
        const product = createProductObject(recommendedProduct);
        if (product) setSelectedProduct(product);
      }
    } catch (err) {
      console.error('Error fetching recommended product:', err);
    } finally {
      setFetchedRecommendedProduct(true);
    }
  }, [productType, getData]);

  const handleCustomProduct = useCallback(async () => {
    const productsList = campaign?.message?.productsList || [];
    if (!productsList.length || !shopDomain || !country) return;

    const randomProduct = productsList[Math.floor(Math.random() * productsList.length)];
    const res = await getData(
      `/products/recommended?${getUrlSearch({
        shop: shopDomain,
        limit: 10,
        type: 'custom',
        productId: randomProduct.id,
        country
      })}`
    );
    if (res.data) {
      const product = createProductObject(res.data.custom);
      if (product) setSelectedProduct(product);
    }
  }, [campaign?.message?.productsList]);

  useEffect(() => {
    if (messageType === DEFAULT_MESSAGE_TYPE.PRODUCT_RECOMMENDATION) {
      if (isPreview) {
        const exampleProduct = {
          // firstVariantId: '41573612126302',
          name: 'Example Product',
          price: '$69.99',
          img:
            'https://cdn.shopify.com/s/files/1/0914/6757/9762/files/paul-shirt-in-grey-flannel-hanashop-com-vn-2.jpg?v=1747987352'
          // onlineStoreUrl:
          //   'https://ag-harry-chatty-local2.myshopify.com/products/bedside-table-cefce'
        };
        setSelectedProduct(exampleProduct);
        return;
      }

      if (productType === 'custom') {
        handleCustomProduct();
      } else {
        fetchRecommendedProduct();
      }
    }
  }, [messageType, productType, fetchRecommendedProduct, handleCustomProduct]);

  return {selectedProduct, fetchedRecommendedProduct};
};

export default useProductRecommendation;
